import BoxMenu from './BoxMenu.container';

export default BoxMenu;
